export default __webpack_public_path__ + "static/media/printer.f27be63e.svg";